import { graphql } from 'gql';

export const bimActKC2OtherTotalsGql = graphql(`
    query bimActKC2OtherTotals($actKC2OtherId: Long!) {
        bimActKC2OtherTotals(actKC2OtherId: $actKC2OtherId) {
            items {
                id
                workOrderSeasonId
                isInflation
                workOrderActiveSeasonId
                name
                total
                sortOrder
                hasTotals
            }
        }
    }
`);

export const bimUseActKC2OtherTotalInflationGql = graphql(`
    mutation bimUseActKC2OtherTotalInflation($actKC2OtherId: Long!, $workOrderSeasonId: Long) {
        bimUseActKC2OtherTotalInflation(actKC2OtherId: $actKC2OtherId, workOrderSeasonId: $workOrderSeasonId) {
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
                metadata
            }
            actionRequired
        }
    }
`);
